// src/components/games/crossroads/gameUtils.ts
// Utility functions for game UI

import { GameState } from './types';

/**
 * Get total shield amount for a specific target
 */
export function getShieldAmount(
  game: GameState,
  targetId: string,
  targetType: 'player' | 'creature'
): number {
  if (!game.preventionShields) return 0;

  return game.preventionShields
    .filter(shield => shield.targetId === targetId && shield.targetType === targetType)
    .reduce((total, shield) => total + shield.amount, 0);
}

/**
 * Get player shield amount
 */
export function getPlayerShield(game: GameState, playerId: number): number {
  return getShieldAmount(game, `player_${playerId}`, 'player');
}

/**
 * Get creature shield amount
 */
export function getCreatureShield(game: GameState, creatureInstanceId: string): number {
  return getShieldAmount(game, creatureInstanceId, 'creature');
}

/**
 * Check if there's a rerollable dice available
 */
export function hasRerollableDice(game: GameState): boolean {
  return !!(game.lastDiceRoll && game.lastDiceRoll.rerollable);
}

/**
 * Get time elapsed since last game event
 */
export function getTimeSinceLastEvent(game: GameState): number {
  if (!game.eventLog || game.eventLog.length === 0) return Infinity;

  const lastEvent = game.eventLog[game.eventLog.length - 1];
  return Date.now() - lastEvent.timestamp;
}
